import clsx from "clsx";

import { TextInput, TextInputProps } from "@mantine/core";
import {
  FieldValues,
  UseControllerProps,
  useController,
} from "react-hook-form";

export type TInputProps<T extends FieldValues> = UseControllerProps<T> &
  TextInputProps;

const TInput = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  className,
  classNames,
  ...props
}: TInputProps<T>) => {
  const {
    field: { value, onChange: fieldOnChange, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <div className={clsx("w-full", className)}>
      <TextInput
        radius="xs"
        variant="unstyled"
        classNames={{
          input: clsx(
            "h-[50px] w-full border-b border-b-primary-500 bg-primary-50 px-4 py-4 text-sm text-black-900 placeholder-gray-500 focus:border-b-primary-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-900 focus-visible:ring-offset-1",
            fieldState.error?.message && "focus:!border focus:!border-red-500",
          ),
          error: "text-red-500",
          ...classNames,
        }}
        inputWrapperOrder={["label", "input", "description", "error"]}
        value={value}
        onChange={(e) => {
          fieldOnChange(e);
          onChange?.(e);
        }}
        {...field}
        {...props}
      />
      {fieldState.error?.message && (
        <span className="mt-1 text-sm leading-3 text-red-500">
          {fieldState.error?.message}
        </span>
      )}
    </div>
  );
};

export default TInput;
